export const header = {
  xfasAccessToken: 'X-FAS-AccessToken',
  xfasAccountNumber: 'X-FAS-AccountNumber',
  xfasAxsUserId: 'AxsUserId',
  xfasBackend: 'X-FAS-Backend',
  xfasContextId: 'X-FAS-ContextId',
  xfasEmail: 'X-FAS-Email',
  xfasRegion: 'X-FAS-Region',
};
